import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import UpdateTicker from "./components/UpdateTicker";
import HeroSection from "./components/HeroSection";
import FeedSection from "./components/FeedSection";
import RankingSection from "./components/RankingSection";
import CollectionsSection from "./components/CollectionsSection";
import CompareSection from "./components/CompareSection";
import GuideSection from "./components/GuideSection";
import TagsSection from "./components/TagsSection";
import FaqSection from "./components/FaqSection";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <UpdateTicker />
      <SiteHeader />
      <main className="w-full flex-1">
        <HeroSection />
        <FeedSection />
        <RankingSection />
        <CollectionsSection />
        <CompareSection />
        <GuideSection />
        <TagsSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}